import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { SET_PLC_POPUP_STATUS } from "./actionTypes";
import { setPlcPopupStatusSuccess, setPlcPopupStatusError } from "./actions";

// Include call API
import { getSystemAPI } from "../../../api/system";

const systemAPI = getSystemAPI();

function* setPlcPopupStatusFetch(action) {
  try {
    const response = yield call(systemAPI.updatePlcPopupStatus, action.payload.status, action.payload.token);
    let plc_popup_status = response.plc_popup_status;
    yield put(setPlcPopupStatusSuccess("Get plc status ok", plc_popup_status));
  } catch (error) {
    yield put(setPlcPopupStatusError(error));
  }
}

export function* watchSetPlcPopupStatus() {
  yield takeEvery(SET_PLC_POPUP_STATUS, setPlcPopupStatusFetch);
}

function* setPlcPopupStatusSaga() {
  yield all([fork(watchSetPlcPopupStatus)]);
}

export default setPlcPopupStatusSaga;
